import { PlayCircle, Award, BookOpen, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { scrollToSection } from "../lib/config";

const MODULES = [
  {
    icon: BookOpen,
    title: "Treinamentos comerciais",
    text: "Aulas objetivas de vendas, atendimento e condução de avaliações para equipes de clínicas.",
  },
  {
    icon: Award,
    title: "Formação de CRC",
    text: "Certificação completa para transformar recepcionistas em Consultores de Relacionamento com o Cliente.",
  },
  {
    icon: PlayCircle,
    title: "Tutoriais da plataforma",
    text: "Trilhas passo a passo para dominar o Pulse Hub: funil, automações, agenda e relatórios.",
  },
];

export default function Academy() {
  return (
    <section id="academy" data-testid="academy-section" className="bg-graphite py-28 lg:py-36 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] rounded-full bg-gold/5 blur-[60px] lg:blur-[120px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <SectionTag>Pulse Academy</SectionTag>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-bone leading-[1.12]" data-testid="academy-title">
              Uma equipe preparada <span className="text-gold">converte mais oportunidades.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base sm:text-lg text-bone/60 leading-relaxed max-w-xl">
              A plataforma de educação do ecossistema Pulse: capacitação contínua para recepção,
              comercial e gestão — porque tecnologia sem gente preparada não gera resultado.
            </p>
          </Reveal>

          <div className="mt-10 space-y-5">
            {MODULES.map((m, i) => (
              <Reveal key={m.title} delay={0.15 + i * 0.08}>
                <div data-testid={`academy-module-${i}`} className="group flex items-start gap-5 bg-ink/50 border border-gold/15 rounded-2xl p-6 hover:border-gold/50 hover:-translate-y-0.5 transition-[transform,border-color] duration-400">
                  <div className="w-12 h-12 rounded-xl bg-graphite border border-gold/25 flex items-center justify-center shrink-0 group-hover:bg-gold transition-colors duration-400">
                    <m.icon size={22} className="text-gold group-hover:text-ink transition-colors duration-400" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-lg text-bone">{m.title}</h3>
                    <p className="mt-1.5 text-sm text-bone/55 leading-relaxed">{m.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.35}>
            <button
              data-testid="academy-cta"
              onClick={() => scrollToSection("#diagnostico")}
              className="mt-10 inline-flex items-center gap-2 text-gold font-display font-bold text-sm uppercase tracking-[0.16em] group"
            >
              Quero capacitar minha equipe
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="relative" data-testid="academy-visual">
            <div className="absolute -inset-3 rounded-[28px] border border-gold/25" />
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://images.pexels.com/photos/7789614/pexels-photo-7789614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Interior premium de clínica de estética"
                className="w-full h-[420px] lg:h-[520px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-ink/35" />
              <div className="absolute bottom-6 left-6 right-6 bg-ink/80 backdrop-blur border border-gold/25 rounded-2xl p-5 flex items-center gap-4">
                <span className="w-12 h-12 rounded-full bg-gold flex items-center justify-center shrink-0">
                  <PlayCircle size={24} className="text-ink" />
                </span>
                <div>
                  <p className="font-display font-bold text-bone text-sm">Trilha: Recepção High-Ticket</p>
                  <p className="text-xs text-bone/55 mt-0.5">12 aulas • Certificado Pulse Academy</p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
